/**
 * Copyright 2023 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useAffinityRelatedProducts } from '@/features/pdpAffinity/api/getAffinityRelatedProducts';
import { useAffinityRelatedProductsACES } from '@/features/pdpAffinity/api/getAffinityRelatedProductsACES';
import { useAddAffinityItemsToCartMutation } from '@/features/pdpAffinity/api/postAddAffinityItemsToCart';
import { AffinityRelatedProductsBlock } from '@/features/pdpAffinity/components/AffinityRelatedProductsBlock';
import { useAcesFlags } from '@/features/ymme/utils/acesFlags';

export type CMSCompleteTheJobProps = {
  shippingType: string;
  fulfillmentId: number;
  itemsToDisplay?: number;
};

export const CMSCompleteTheJob = ({
  shippingType,
  fulfillmentId,
  itemsToDisplay,
}: CMSCompleteTheJobProps) => {
  const { acesEnabled, acesNonVehicleEndpointsEnabled } = useAcesFlags();
  const useAffinity =
    acesEnabled && acesNonVehicleEndpointsEnabled
      ? useAffinityRelatedProductsACES
      : useAffinityRelatedProducts;
  const { data: affinityRelatedProducts } = useAffinity({
    itemsToDisplay,
  });

  const addAffinityItemsToCartMutation = useAddAffinityItemsToCartMutation();

  if (!affinityRelatedProducts?.length) {
    return null;
  }

  return (
    <AffinityRelatedProductsBlock
      affinityRelatedProducts={affinityRelatedProducts}
      shippingType={shippingType}
      fulfillmentId={fulfillmentId}
      addAffinityItemsToCartMutation={addAffinityItemsToCartMutation}
    />
  );
};
